'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';
import type { ResponsiveDialogConfig } from '@/stores/ResponsiveDialogStore';
interface ReviewPendingSheetProps {
  applicationId: string;
}
const REVIEW_PENDING_TITLE = '후기를 작성하지 않은\n체험단 답례품이 있네요!';
export const ReviewPendingSheet = t0 => {
  const $ = _c(7);
  const {
    applicationId
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex flex-col gap-32", "mobile-tablet:gap-24");
    t2 = <div className={cn("flex flex-col gap-12", "mobile-tablet:gap-16")}><p className="whitespace-pre-line text-start text-Gray-700 typo-body3">{"\uB2F5\uB840\uD488\uC744 \uBC1B\uC740 \uD6C4 \uBBF8\uC791\uC131\uD55C \uACBD\uC6B0\n\uCCB4\uD5D8\uB2E8\uC5D0 \uCC38\uC5EC\uD558\uC9C0 \uBABB\uD558\uB294 \uBD88\uC774\uC775\uC744 \uBC1B\uC744 \uC218 \uC788\uC5B4\uC694."}</p><p className={cn("text-start text-M-500 typo-body4", "mobile-tablet:font-600 mobile-tablet:typo-caption1")}>후기 작성 기간 : 배송 완료일로부터 10일 이내</p></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== applicationId) {
    t3 = DONATION_ROUTES.GIFT_TRIAL_REVIEW.withSearchParams({
      dynamicPath: {
        applicationId
      }
    });
    $[2] = applicationId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgChevronright className="size-16" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className={t1}>{t2}<Button asChild={true} className="w-full"><CustomLink href={t3}>후기 작성하기{t4}</CustomLink></Button></div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export const createReviewPendingDialog = (applicationId: string): ResponsiveDialogConfig => ({
  component: ReviewPendingSheet,
  title: REVIEW_PENDING_TITLE,
  modalHeader: REVIEW_PENDING_TITLE,
  drawerType: 'bottom',
  props: {
    applicationId
  }
});